import React, { useState } from 'react'
import DebtManagement from '../DebtManagement'
import ProvisionList from './ProvisionList'
import { useSelector } from 'react-redux'
import { CHECK_COMPANY_TENANT, Company_DATA, CREDFIN_LIKE } from '../../../../../layouts/MainTenantconfig'
export default function Main({ admin, nbfcList, userDetailHandler,productList }) {
    const tenant = useSelector((state)=>state.tenant.activeTenant)
    const [view, setView] = useState("debtView")

    const handleview = (type) => {
        setView(type)
    }
    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: view == "debtView" ? "absolute" : 'relative', border: CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?  '1px solid #006c67' : "1px solid #006fbc", borderRadius: '6px', marginTop: '22px', display: 'inline-block' }}>
                    <button className="btn" style={{ width: '100px', padding: '11px 10px', background: view === "provisionView" ? CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?  "#006c67" : "#006fbc" : "#fff", color: view === "provisionView" ?  "#fff" : CHECK_COMPANY_TENANT(CREDFIN_LIKE) ? "#006c67" : "#006fbc", borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} onClick={() => handleview("provisionView")}>Provision</button>
                    <button className="btn" style={{ width: '100px', padding: '11px 10px', background: view === "debtView" ? CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?  "#006c67" : "#006fbc" : "#fff", color: view === "debtView" ? "#fff" : CHECK_COMPANY_TENANT(CREDFIN_LIKE) ? "#006c67" : "#006fbc", borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }} onClick={() => handleview("debtView")}>List</button>
                </div>
                
                {
                    view == "debtView" ?
                        <DebtManagement nbfcList={nbfcList} userDetailHandler={userDetailHandler} handleview={handleview} productList={productList}/>
                        : ''}

                {
                    view == "provisionView" ?
                        <ProvisionList admin={admin} nbfcList={nbfcList} />
                        : ''}
            </div>

        </>
    )
}
